// cart-ajax.js — real Shopify cart wired to the Trendelo drawer markup.
// Uses the Section Rendering API so the drawer re-renders with the exact same
// Liquid/CSS as sections/cart-drawer.liquid (no money-format drift).
(function () {
  var SECTION = "cart-drawer";

  function openDrawer() {
    var sc = document.querySelector(".scrim"), dr = document.querySelector(".drawer");
    if (sc) sc.setAttribute("data-open", "1");
    if (dr) dr.setAttribute("data-open", "1");
    document.body.style.overflow = "hidden";
  }
  function bump() {
    [].forEach.call(document.querySelectorAll(".cart-dot"), function (d) {
      d.classList.remove("bumping"); void d.offsetWidth; d.classList.add("bumping");
    });
  }

  // Replace the drawer's inner markup with freshly-rendered section HTML.
  function paintSection(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, "text/html");
    var freshBody = parsed.getElementById("cartBody");
    var freshFoot = parsed.getElementById("cartFoot");
    var body = document.getElementById("cartBody");
    var foot = document.getElementById("cartFoot");
    if (freshBody && body) body.innerHTML = freshBody.innerHTML;
    if (freshFoot && foot) foot.innerHTML = freshFoot.innerHTML;
  }

  function refreshCount() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        [].forEach.call(document.querySelectorAll(".cart-dot b"), function (b) {
          b.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function addToCart(variantId, qty) {
    if (!variantId) return Promise.resolve();
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }], sections: [SECTION] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.sections && res.sections[SECTION]) paintSection(res.sections[SECTION]);
        bump(); openDrawer();
        return refreshCount();
      })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty, sections: [SECTION] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.sections && res.sections[SECTION]) paintSection(res.sections[SECTION]);
        else if (res && res.items) {
          // change.js without sections support: hard refresh drawer via cart.js render
        }
        return refreshCount();
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    // Quick-add on product cards (skipped in "coming soon" mode — ui.js intercepts those)
    var qa = e.target.closest("[data-quick-add]");
    if (qa && !qa.closest(".coming")) {
      e.preventDefault(); e.stopPropagation();
      addToCart(qa.getAttribute("data-variant-id"), 1);
      return;
    }

    // Drawer line controls
    var item = e.target.closest(".cart-item");
    if (item) {
      var key = item.getAttribute("data-key");
      var cur = parseInt(item.getAttribute("data-qty") || "1", 10);
      if (e.target.closest("[data-dec]")) { changeLine(key, Math.max(0, cur - 1)); return; }
      if (e.target.closest("[data-inc]")) { changeLine(key, cur + 1); return; }
      if (e.target.closest("[data-remove]")) { changeLine(key, 0); return; }
    }
  });

  // Product page add-to-cart form
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var variantId = idField ? idField.value : null;
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    addToCart(variantId, qty);
  });

  if (document.readyState !== "loading") refreshCount();
  else document.addEventListener("DOMContentLoaded", refreshCount);
})();
